var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2456C81A-F813-4D6B-928A-AD3073DD2E70") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Owners-over-15%-Listed",
    transform: "translate(-615.000000, -1115.000000)",
    fill: "#B0B0B0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(599.499508, 1102.426516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(16.000000, 12.700000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37207031,0 C4.26393457,0 2.54882812,1.71510645 2.54882812,3.82324219 C2.54882812,5.93137793 4.26393457,7.64648437 6.37207031,7.64648437 C8.48020605,7.64648437 10.1953125,5.93137793 10.1953125,3.82324219 C10.1953125,1.71510645 8.48020605,0 6.37207031,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1289199,10.1441943 C10.0822012,9.08138965 8.69459082,8.49609375 7.22167969,8.49609375 L5.52246094,8.49609375 C4.04957813,8.49609375 2.66193945,9.08138965 1.6152207,10.1441943 C0.57362793,11.2017881 0,12.5978096 0,14.0751953 C0,14.3098008 0.190199219,14.5 0.424804688,14.5 L12.3193359,14.5 C12.5539414,14.5 12.7441406,14.3098008 12.7441406,14.0751953 C12.7441406,12.5978096 12.1705127,11.2017881 11.1289199,10.1441943 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdit);
export default __webpack_public_path__ + "static/media/user-edit.ef18aecb6d13f99c1abe150abad4684c.svg";
export { ForwardRef as ReactComponent };